// Canonical lists used by the architect application wizard and the
// architect's profile editor. These are intentionally narrow:
//
//  • SERVICE_AREAS — Today every architect serves Indianapolis as a
//    whole. Splitting by neighborhood is too granular for the current
//    catalog size; we will add new metro service areas (Bloomington,
//    Fort Wayne, …) as the catalog grows. NOT to be confused with
//    parcels, which DO track neighborhoods — those filters live in
//    Marketplace / Parcels / City Reports and are unrelated.
//
//  • ARCHITECT_TYPOLOGIES — The typology classes WHOLE currently
//    underwrites for pre-review. Cottage, Missing Middle, and Adaptive
//    Reuse are on the future roadmap.

export const SERVICE_AREAS = ["Indianapolis"];

export const ARCHITECT_TYPOLOGIES = [
  { key: "single_family", label: "Single-Family" },
  { key: "duplex",        label: "Duplex" },
  { key: "adu",           label: "ADU" },
];

export const DEMOGRAPHIC_FLAGS = ["MBE", "WBE", "VBE", "Local Indianapolis"];
